<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="editItem = {}"
    >
      Add Okta Federation
    </v-btn>
    <federation-table-modal v-if="editItem" :edited-item="editItem" @close="editItem = null" />
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      class="elevation-1"
      item-key="federationId"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td class="justify-center">
            <v-btn tooltip.hover title="Edit Federation" icon class="mx-0" @click="editItem = cloneDeep(props.item)">
              <v-icon color="primary">edit</v-icon>
            </v-btn>
            <v-btn tooltip.hover title="Delete Federation" icon class="mx-0" @click="deleteThisFederation(props.item.federationId)">
              <v-icon color="primary">delete</v-icon>
            </v-btn>
          </td>
          <td class="justify-center">
            <v-btn tooltip.hover title="SSO User Groups" icon class="mx-0" @click.native="$emit('sso', props.item.federationId)">
              <v-icon color="primary">subdirectory_arrow_right</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.domain }}</td>
          <td>{{ props.item.logoutHome }}</td>
          <td>{{ props.item.changePassword }}</td>
          <td>{{ props.item.credentialProviderType }}</td>
          <td>{{ props.item.credentialProviderName }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import FederationTableModal from './FederationTableModal'
import cloneDeep from 'lodash/cloneDeep'
import { mapActions } from 'vuex'

export default {
  name: 'client-table',
  components: {
    FederationTableModal
  },
  props: {
    tableItems: Array
  },
  data() {
    return {
      editItem: null,
      ssoGroups: null,
      tableHeaders: [
        {
          text: 'Edit / Delete',
          value: false,
          sortable: false
        },
        {
          text: 'SSO User Groups',
          value: false,
          sortable: false
        },
        {
          text: 'Domain',
          value: 'domain'
        },
        {
          text: 'Logout Home',
          value: 'logoutHome'
        },
        {
          text: 'Change Password',
          value: 'changePassword'
        },
        {
          text: 'Provider Type',
          value: 'credentialProviderType'
        },
        {
          text: 'Provider Name',
          value: 'credentialProviderName'
        }
      ]
    }
  },
  methods: {
    ...mapActions('oktaFederations', ['deleteFederation']),
    cloneDeep: cloneDeep,
    deleteThisFederation(federationId) {
      this.deleteFederation(federationId)
    }
  }
}
</script>
